export const GET_BY_KEY = 'GET_BY_KEY';
export const GET_TEXT_FROM = 'GET_TEXT_FROM';
export const GET_TEXT = 'GET_TEXT';
export const GET_TEXT_NO_QUESTION_MARK = 'GET_TEXT_NO_QUESTION_MARK';
export const GET_TISK_TEXT = 'GET_TISK_TEXT';
export const GET_HINT = 'GET_HINT';
export const GET_ZKRATKA = 'GET_ZKRATKA';
export const POPIS_POLI = 'Popispoli';
export const POPIS_OSTATNI = 'Popisostatni';
export const CHYBOVE_HLASKY = 'ChyboveHlasky';
export const STATIC = 'Static';
export const MENU = 'Menu';
export const FORMULAR = 'Formular';

export const IS_AUTH = 'IS_AUTH';
export const TOKEN = 'TOKEN';
export const AUTH_USER = 'AUTH_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const CRUMBS = 'CRUMBS';
export const FISKAL_MODE_ENABLED = 'FISKAL_MODE_ENABLED';

/**
 * Single sign on
 */
export const SSO_STATE_SIGNOUT = 'SSO_STATE_SIGNOUT';
export const SSO_STATE_ERROR = 'SSO_STATE_ERROR';
